import sharedDetailsApi from 'api/ApiActions/Reporting/Overview/ShareDashboard'
/**
 *
 * @param action which api needs to get called
 * @returns api data
 */
export const handleApiCalls = async ({ action, sharedId }: any) => {
  const {
    updateSharedData,
    deleteLinkdData,
    updatePasswordData,
    getSharedData,
  } = sharedDetailsApi

  const apiAction: any = {
    getSharedData: () => getSharedData(),
    updateLink: () => updateSharedData(sharedId),
    deleteLink: () => deleteLinkdData(sharedId),
    getPassword: () =>
      updatePasswordData({ is_password_enabled: true, sharedId }),
    deletePassword: () =>
      updatePasswordData({ is_password_enabled: false, sharedId }),
  }

  return apiAction[action]?.()
}
